import React from 'react';

import Html from 'views/components/html';
import Header from 'views/components/header';
import Body from 'views/components/body';
import GoogleMap from 'views/components/google-map';
import Footer from 'views/components/footer';
import { Map, Information } from './index.styled';

const Access = () => {
  return (
    <>
      <Html title="アクセス" />
      <Header />
      <Body>
        <Map>
          <GoogleMap />
        </Map>
        <Information>
          <dl>
            <dt>住所</dt>
            <dd><a href="https://goo.gl/maps/CPqEX239gFjDzmvR7" target="_blank">〒577-0016　大阪府東大阪市長田西5丁目1番15号</a></dd>
            <dt>TEL</dt>
            <dd>06-6747-1118（代）</dd>
            <dt>FAX</dt>
            <dd>06-6747-1188</dd>
            <dt>MAIL</dt>
            <dd><a href="mailto:info@nonakass.com">info@nonakass.com</a></dd>
          </dl>
        </Information>
      </Body>
      <Footer />
    </>
  );
};

export default Access;
